/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ZapomenuteHesloRouteImport } from './routes/zapomenute-heslo'
import { Route as TerminyRouteImport } from './routes/terminy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ObchodniPodminkyRouteImport } from './routes/obchodni-podminky'
import { Route as ONasRouteImport } from './routes/o-nas'
import { Route as NasTymRouteImport } from './routes/nas-tym'
import { Route as GdprRouteImport } from './routes/gdpr'
import { Route as DiagnozaRouteImport } from './routes/diagnoza'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as ZpetnaVazbaTokenRouteImport } from './routes/zpetna-vazba/$token'
import { Route as SeminareSlugRouteImport } from './routes/seminare/$slug'
import { Route as RegistraceTerminIdRouteImport } from './routes/registrace/$terminId'
import { Route as PotvrzeniTokenRouteImport } from './routes/potvrzeni/$token'
import { Route as OdhlasitTokenRouteImport } from './routes/odhlasit/$token'
import { Route as KioskTerminIdRouteImport } from './routes/kiosk/$terminId'
import { Route as DashboardZpetnaVazbaRouteImport } from './routes/dashboard/zpetna-vazba'
import { Route as DashboardTerminyRouteImport } from './routes/dashboard/terminy'
import { Route as DashboardTasksRouteImport } from './routes/dashboard/tasks'
import { Route as DashboardProvizeRouteImport } from './routes/dashboard/provize'
import { Route as DashboardProgramyRouteImport } from './routes/dashboard/programy'
import { Route as DashboardProduktyRouteImport } from './routes/dashboard/produkty'
import { Route as DashboardPrihlaskyRouteImport } from './routes/dashboard/prihlasky'
import { Route as DashboardPipelineRouteImport } from './routes/dashboard/pipeline'
import { Route as DashboardNotificationsRouteImport } from './routes/dashboard/notifications'
import { Route as DashboardNotesRouteImport } from './routes/dashboard/notes'
import { Route as DashboardNastaveniRouteImport } from './routes/dashboard/nastaveni'
import { Route as DashboardLektoriRouteImport } from './routes/dashboard/lektori'
import { Route as DashboardKontaktRouteImport } from './routes/dashboard/kontakt'
import { Route as DashboardKlientiRouteImport } from './routes/dashboard/klienti'
import { Route as DashboardFirmyRouteImport } from './routes/dashboard/firmy'
import { Route as DashboardFakturyRouteImport } from './routes/dashboard/faktury'
import { Route as DashboardDokumentyRouteImport } from './routes/dashboard/dokumenty'
import { Route as DashboardChecklistsRouteImport } from './routes/dashboard/checklists'
import { Route as DashboardAktivityRouteImport } from './routes/dashboard/aktivity'
import { Route as DashboardAdminRouteImport } from './routes/dashboard/admin'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as DashboardPozorovaniIndexRouteImport } from './routes/dashboard/pozorovani/index'
import { Route as DashboardDochazkaIndexRouteImport } from './routes/dashboard/dochazka/index'
import { Route as DashboardAdminIndexRouteImport } from './routes/dashboard/admin/index'
import { Route as DashboardTerminyTerminIdRouteImport } from './routes/dashboard/terminy_.$terminId'
import { Route as DashboardRoleOpsRouteImport } from './routes/dashboard/role/ops'
import { Route as DashboardRoleObchodnikRouteImport } from './routes/dashboard/role/obchodnik'
import { Route as DashboardRoleLektorRouteImport } from './routes/dashboard/role/lektor'
import { Route as DashboardRoleAsistentRouteImport } from './routes/dashboard/role/asistent'
import { Route as DashboardPozorovaniDochazkaIdRouteImport } from './routes/dashboard/pozorovani/$dochazkaId'
import { Route as DashboardMarketingTagsRouteImport } from './routes/dashboard/marketing/tags'
import { Route as DashboardMarketingLeadMagnetRouteImport } from './routes/dashboard/marketing/lead-magnet'
import { Route as DashboardMarketingKomunikaceRouteImport } from './routes/dashboard/marketing/komunikace'
import { Route as DashboardMarketingEmailTemplatesRouteImport } from './routes/dashboard/marketing/email-templates'
import { Route as DashboardMarketingEmailSerialyRouteImport } from './routes/dashboard/marketing/email-serialy'
import { Route as DashboardMarketingEmailCampaignsRouteImport } from './routes/dashboard/marketing/email-campaigns'
import { Route as DashboardMarketingEmailAnalyticsRouteImport } from './routes/dashboard/marketing/email-analytics'
import { Route as DashboardKlientiKlientIdRouteImport } from './routes/dashboard/klienti_.$klientId'
import { Route as DashboardFirmyFirmaIdRouteImport } from './routes/dashboard/firmy_.$firmaId'
import { Route as DashboardDochazkaTerminIdRouteImport } from './routes/dashboard/dochazka/$terminId'
import { Route as DashboardAnalyticsEkonomikaRouteImport } from './routes/dashboard/analytics/ekonomika'
import { Route as DashboardAdminUsersRouteImport } from './routes/dashboard/admin/users'
import { Route as DashboardAdminQueuesRouteImport } from './routes/dashboard/admin/queues'
import { Route as DashboardAdminNastrojeRouteImport } from './routes/dashboard/admin/nastroje'
import { Route as DashboardAdminMcpRouteImport } from './routes/dashboard/admin/mcp'
import { Route as DashboardAdminAuditRouteImport } from './routes/dashboard/admin/audit'

const ZapomenuteHesloRoute = ZapomenuteHesloRouteImport.update({
  id: '/zapomenute-heslo',
  path: '/zapomenute-heslo',
  getParentRoute: () => rootRouteImport,
} as any)
const TerminyRoute = TerminyRouteImport.update({
  id: '/terminy',
  path: '/terminy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ObchodniPodminkyRoute = ObchodniPodminkyRouteImport.update({
  id: '/obchodni-podminky',
  path: '/obchodni-podminky',
  getParentRoute: () => rootRouteImport,
} as any)
const ONasRoute = ONasRouteImport.update({
  id: '/o-nas',
  path: '/o-nas',
  getParentRoute: () => rootRouteImport,
} as any)
const NasTymRoute = NasTymRouteImport.update({
  id: '/nas-tym',
  path: '/nas-tym',
  getParentRoute: () => rootRouteImport,
} as any)
const GdprRoute = GdprRouteImport.update({
  id: '/gdpr',
  path: '/gdpr',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagnozaRoute = DiagnozaRouteImport.update({
  id: '/diagnoza',
  path: '/diagnoza',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/diagnoza.lazy').then((d) => d.Route))
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/index.lazy').then((d) => d.Route),
)
const ZpetnaVazbaTokenRoute = ZpetnaVazbaTokenRouteImport.update({
  id: '/zpetna-vazba/$token',
  path: '/zpetna-vazba/$token',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/zpetna-vazba/$token.lazy').then((d) => d.Route),
)
const SeminareSlugRoute = SeminareSlugRouteImport.update({
  id: '/seminare/$slug',
  path: '/seminare/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistraceTerminIdRoute = RegistraceTerminIdRouteImport.update({
  id: '/registrace/$terminId',
  path: '/registrace/$terminId',
  getParentRoute: () => rootRouteImport,
} as any)
const PotvrzeniTokenRoute = PotvrzeniTokenRouteImport.update({
  id: '/potvrzeni/$token',
  path: '/potvrzeni/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OdhlasitTokenRoute = OdhlasitTokenRouteImport.update({
  id: '/odhlasit/$token',
  path: '/odhlasit/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const KioskTerminIdRoute = KioskTerminIdRouteImport.update({
  id: '/kiosk/$terminId',
  path: '/kiosk/$terminId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/kiosk/$terminId.lazy').then((d) => d.Route),
)
const DashboardZpetnaVazbaRoute = DashboardZpetnaVazbaRouteImport.update({
  id: '/zpetna-vazba',
  path: '/zpetna-vazba',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/zpetna-vazba.lazy').then((d) => d.Route),
)
const DashboardTerminyRoute = DashboardTerminyRouteImport.update({
  id: '/terminy',
  path: '/terminy',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/terminy.lazy').then((d) => d.Route),
)
const DashboardTasksRoute = DashboardTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/tasks.lazy').then((d) => d.Route),
)
const DashboardProvizeRoute = DashboardProvizeRouteImport.update({
  id: '/provize',
  path: '/provize',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/provize.lazy').then((d) => d.Route),
)
const DashboardProgramyRoute = DashboardProgramyRouteImport.update({
  id: '/programy',
  path: '/programy',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/programy.lazy').then((d) => d.Route),
)
const DashboardProduktyRoute = DashboardProduktyRouteImport.update({
  id: '/produkty',
  path: '/produkty',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/produkty.lazy').then((d) => d.Route),
)
const DashboardPrihlaskyRoute = DashboardPrihlaskyRouteImport.update({
  id: '/prihlasky',
  path: '/prihlasky',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/prihlasky.lazy').then((d) => d.Route),
)
const DashboardPipelineRoute = DashboardPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/pipeline.lazy').then((d) => d.Route),
)
const DashboardNotificationsRoute = DashboardNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/notifications.lazy').then((d) => d.Route),
)
const DashboardNotesRoute = DashboardNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/notes.lazy').then((d) => d.Route),
)
const DashboardNastaveniRoute = DashboardNastaveniRouteImport.update({
  id: '/nastaveni',
  path: '/nastaveni',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/nastaveni.lazy').then((d) => d.Route),
)
const DashboardLektoriRoute = DashboardLektoriRouteImport.update({
  id: '/lektori',
  path: '/lektori',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/lektori.lazy').then((d) => d.Route),
)
const DashboardKontaktRoute = DashboardKontaktRouteImport.update({
  id: '/kontakt',
  path: '/kontakt',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/kontakt.lazy').then((d) => d.Route),
)
const DashboardKlientiRoute = DashboardKlientiRouteImport.update({
  id: '/klienti',
  path: '/klienti',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/klienti.lazy').then((d) => d.Route),
)
const DashboardFirmyRoute = DashboardFirmyRouteImport.update({
  id: '/firmy',
  path: '/firmy',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/firmy.lazy').then((d) => d.Route),
)
const DashboardFakturyRoute = DashboardFakturyRouteImport.update({
  id: '/faktury',
  path: '/faktury',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/faktury.lazy').then((d) => d.Route),
)
const DashboardDokumentyRoute = DashboardDokumentyRouteImport.update({
  id: '/dokumenty',
  path: '/dokumenty',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/dokumenty.lazy').then((d) => d.Route),
)
const DashboardChecklistsRoute = DashboardChecklistsRouteImport.update({
  id: '/checklists',
  path: '/checklists',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/checklists.lazy').then((d) => d.Route),
)
const DashboardAktivityRoute = DashboardAktivityRouteImport.update({
  id: '/aktivity',
  path: '/aktivity',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/aktivity.lazy').then((d) => d.Route),
)
const DashboardAdminRoute = DashboardAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/admin.lazy').then((d) => d.Route),
)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const DashboardPozorovaniIndexRoute =
  DashboardPozorovaniIndexRouteImport.update({
    id: '/pozorovani/',
    path: '/pozorovani/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/pozorovani/index.lazy').then((d) => d.Route),
  )
const DashboardDochazkaIndexRoute = DashboardDochazkaIndexRouteImport.update({
  id: '/dochazka/',
  path: '/dochazka/',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/dochazka/index.lazy').then((d) => d.Route),
)
const DashboardAdminIndexRoute = DashboardAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAdminRoute,
} as any)
const DashboardTerminyTerminIdRoute =
  DashboardTerminyTerminIdRouteImport.update({
    id: '/terminy_/$terminId',
    path: '/terminy/$terminId',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/terminy_.$terminId.lazy').then((d) => d.Route),
  )
const DashboardRoleOpsRoute = DashboardRoleOpsRouteImport.update({
  id: '/role/ops',
  path: '/role/ops',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/role/ops.lazy').then((d) => d.Route),
)
const DashboardRoleObchodnikRoute = DashboardRoleObchodnikRouteImport.update({
  id: '/role/obchodnik',
  path: '/role/obchodnik',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/role/obchodnik.lazy').then((d) => d.Route),
)
const DashboardRoleLektorRoute = DashboardRoleLektorRouteImport.update({
  id: '/role/lektor',
  path: '/role/lektor',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/role/lektor.lazy').then((d) => d.Route),
)
const DashboardRoleAsistentRoute = DashboardRoleAsistentRouteImport.update({
  id: '/role/asistent',
  path: '/role/asistent',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/role/asistent.lazy').then((d) => d.Route),
)
const DashboardPozorovaniDochazkaIdRoute =
  DashboardPozorovaniDochazkaIdRouteImport.update({
    id: '/pozorovani/$dochazkaId',
    path: '/pozorovani/$dochazkaId',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/pozorovani/$dochazkaId.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardMarketingTagsRoute = DashboardMarketingTagsRouteImport.update({
  id: '/marketing/tags',
  path: '/marketing/tags',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/marketing/tags.lazy').then((d) => d.Route),
)
const DashboardMarketingLeadMagnetRoute =
  DashboardMarketingLeadMagnetRouteImport.update({
    id: '/marketing/lead-magnet',
    path: '/marketing/lead-magnet',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/marketing/lead-magnet.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardMarketingKomunikaceRoute =
  DashboardMarketingKomunikaceRouteImport.update({
    id: '/marketing/komunikace',
    path: '/marketing/komunikace',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/marketing/komunikace.lazy').then((d) => d.Route),
  )
const DashboardMarketingEmailTemplatesRoute =
  DashboardMarketingEmailTemplatesRouteImport.update({
    id: '/marketing/email-templates',
    path: '/marketing/email-templates',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/marketing/email-templates.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardMarketingEmailSerialyRoute =
  DashboardMarketingEmailSerialyRouteImport.update({
    id: '/marketing/email-serialy',
    path: '/marketing/email-serialy',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/marketing/email-serialy.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardMarketingEmailCampaignsRoute =
  DashboardMarketingEmailCampaignsRouteImport.update({
    id: '/marketing/email-campaigns',
    path: '/marketing/email-campaigns',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/marketing/email-campaigns.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardMarketingEmailAnalyticsRoute =
  DashboardMarketingEmailAnalyticsRouteImport.update({
    id: '/marketing/email-analytics',
    path: '/marketing/email-analytics',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/marketing/email-analytics.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardKlientiKlientIdRoute =
  DashboardKlientiKlientIdRouteImport.update({
    id: '/klienti_/$klientId',
    path: '/klienti/$klientId',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/klienti_.$klientId.lazy').then((d) => d.Route),
  )
const DashboardFirmyFirmaIdRoute = DashboardFirmyFirmaIdRouteImport.update({
  id: '/firmy_/$firmaId',
  path: '/firmy/$firmaId',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/firmy_.$firmaId.lazy').then((d) => d.Route),
)
const DashboardDochazkaTerminIdRoute =
  DashboardDochazkaTerminIdRouteImport.update({
    id: '/dochazka/$terminId',
    path: '/dochazka/$terminId',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/dochazka/$terminId.lazy').then((d) => d.Route),
  )
const DashboardAnalyticsEkonomikaRoute =
  DashboardAnalyticsEkonomikaRouteImport.update({
    id: '/analytics/ekonomika',
    path: '/analytics/ekonomika',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/analytics/ekonomika.lazy').then((d) => d.Route),
  )
const DashboardAdminUsersRoute = DashboardAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DashboardAdminRoute,
} as any).lazy(() =>
  import('./routes/dashboard/admin/users.lazy').then((d) => d.Route),
)
const DashboardAdminQueuesRoute = DashboardAdminQueuesRouteImport.update({
  id: '/queues',
  path: '/queues',
  getParentRoute: () => DashboardAdminRoute,
} as any).lazy(() =>
  import('./routes/dashboard/admin/queues.lazy').then((d) => d.Route),
)
const DashboardAdminNastrojeRoute = DashboardAdminNastrojeRouteImport.update({
  id: '/nastroje',
  path: '/nastroje',
  getParentRoute: () => DashboardAdminRoute,
} as any).lazy(() =>
  import('./routes/dashboard/admin/nastroje.lazy').then((d) => d.Route),
)
const DashboardAdminMcpRoute = DashboardAdminMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => DashboardAdminRoute,
} as any).lazy(() =>
  import('./routes/dashboard/admin/mcp.lazy').then((d) => d.Route),
)
const DashboardAdminAuditRoute = DashboardAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => DashboardAdminRoute,
} as any).lazy(() =>
  import('./routes/dashboard/admin/audit.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/diagnoza': typeof DiagnozaRoute
  '/gdpr': typeof GdprRoute
  '/nas-tym': typeof NasTymRoute
  '/o-nas': typeof ONasRoute
  '/obchodni-podminky': typeof ObchodniPodminkyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terminy': typeof TerminyRoute
  '/zapomenute-heslo': typeof ZapomenuteHesloRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/dashboard/admin': typeof DashboardAdminRouteWithChildren
  '/dashboard/aktivity': typeof DashboardAktivityRoute
  '/dashboard/checklists': typeof DashboardChecklistsRoute
  '/dashboard/dokumenty': typeof DashboardDokumentyRoute
  '/dashboard/faktury': typeof DashboardFakturyRoute
  '/dashboard/firmy': typeof DashboardFirmyRoute
  '/dashboard/klienti': typeof DashboardKlientiRoute
  '/dashboard/kontakt': typeof DashboardKontaktRoute
  '/dashboard/lektori': typeof DashboardLektoriRoute
  '/dashboard/nastaveni': typeof DashboardNastaveniRoute
  '/dashboard/notes': typeof DashboardNotesRoute
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/pipeline': typeof DashboardPipelineRoute
  '/dashboard/prihlasky': typeof DashboardPrihlaskyRoute
  '/dashboard/produkty': typeof DashboardProduktyRoute
  '/dashboard/programy': typeof DashboardProgramyRoute
  '/dashboard/provize': typeof DashboardProvizeRoute
  '/dashboard/tasks': typeof DashboardTasksRoute
  '/dashboard/terminy': typeof DashboardTerminyRoute
  '/dashboard/zpetna-vazba': typeof DashboardZpetnaVazbaRoute
  '/kiosk/$terminId': typeof KioskTerminIdRoute
  '/odhlasit/$token': typeof OdhlasitTokenRoute
  '/potvrzeni/$token': typeof PotvrzeniTokenRoute
  '/registrace/$terminId': typeof RegistraceTerminIdRoute
  '/seminare/$slug': typeof SeminareSlugRoute
  '/zpetna-vazba/$token': typeof ZpetnaVazbaTokenRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/admin/audit': typeof DashboardAdminAuditRoute
  '/dashboard/admin/mcp': typeof DashboardAdminMcpRoute
  '/dashboard/admin/nastroje': typeof DashboardAdminNastrojeRoute
  '/dashboard/admin/queues': typeof DashboardAdminQueuesRoute
  '/dashboard/admin/users': typeof DashboardAdminUsersRoute
  '/dashboard/analytics/ekonomika': typeof DashboardAnalyticsEkonomikaRoute
  '/dashboard/dochazka/$terminId': typeof DashboardDochazkaTerminIdRoute
  '/dashboard/firmy/$firmaId': typeof DashboardFirmyFirmaIdRoute
  '/dashboard/klienti/$klientId': typeof DashboardKlientiKlientIdRoute
  '/dashboard/marketing/email-analytics': typeof DashboardMarketingEmailAnalyticsRoute
  '/dashboard/marketing/email-campaigns': typeof DashboardMarketingEmailCampaignsRoute
  '/dashboard/marketing/email-serialy': typeof DashboardMarketingEmailSerialyRoute
  '/dashboard/marketing/email-templates': typeof DashboardMarketingEmailTemplatesRoute
  '/dashboard/marketing/komunikace': typeof DashboardMarketingKomunikaceRoute
  '/dashboard/marketing/lead-magnet': typeof DashboardMarketingLeadMagnetRoute
  '/dashboard/marketing/tags': typeof DashboardMarketingTagsRoute
  '/dashboard/pozorovani/$dochazkaId': typeof DashboardPozorovaniDochazkaIdRoute
  '/dashboard/role/asistent': typeof DashboardRoleAsistentRoute
  '/dashboard/role/lektor': typeof DashboardRoleLektorRoute
  '/dashboard/role/obchodnik': typeof DashboardRoleObchodnikRoute
  '/dashboard/role/ops': typeof DashboardRoleOpsRoute
  '/dashboard/terminy/$terminId': typeof DashboardTerminyTerminIdRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/dochazka/': typeof DashboardDochazkaIndexRoute
  '/dashboard/pozorovani/': typeof DashboardPozorovaniIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/diagnoza': typeof DiagnozaRoute
  '/gdpr': typeof GdprRoute
  '/nas-tym': typeof NasTymRoute
  '/o-nas': typeof ONasRoute
  '/obchodni-podminky': typeof ObchodniPodminkyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terminy': typeof TerminyRoute
  '/zapomenute-heslo': typeof ZapomenuteHesloRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/dashboard/aktivity': typeof DashboardAktivityRoute
  '/dashboard/checklists': typeof DashboardChecklistsRoute
  '/dashboard/dokumenty': typeof DashboardDokumentyRoute
  '/dashboard/faktury': typeof DashboardFakturyRoute
  '/dashboard/firmy': typeof DashboardFirmyRoute
  '/dashboard/klienti': typeof DashboardKlientiRoute
  '/dashboard/kontakt': typeof DashboardKontaktRoute
  '/dashboard/lektori': typeof DashboardLektoriRoute
  '/dashboard/nastaveni': typeof DashboardNastaveniRoute
  '/dashboard/notes': typeof DashboardNotesRoute
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/pipeline': typeof DashboardPipelineRoute
  '/dashboard/prihlasky': typeof DashboardPrihlaskyRoute
  '/dashboard/produkty': typeof DashboardProduktyRoute
  '/dashboard/programy': typeof DashboardProgramyRoute
  '/dashboard/provize': typeof DashboardProvizeRoute
  '/dashboard/tasks': typeof DashboardTasksRoute
  '/dashboard/terminy': typeof DashboardTerminyRoute
  '/dashboard/zpetna-vazba': typeof DashboardZpetnaVazbaRoute
  '/kiosk/$terminId': typeof KioskTerminIdRoute
  '/odhlasit/$token': typeof OdhlasitTokenRoute
  '/potvrzeni/$token': typeof PotvrzeniTokenRoute
  '/registrace/$terminId': typeof RegistraceTerminIdRoute
  '/seminare/$slug': typeof SeminareSlugRoute
  '/zpetna-vazba/$token': typeof ZpetnaVazbaTokenRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/admin/audit': typeof DashboardAdminAuditRoute
  '/dashboard/admin/mcp': typeof DashboardAdminMcpRoute
  '/dashboard/admin/nastroje': typeof DashboardAdminNastrojeRoute
  '/dashboard/admin/queues': typeof DashboardAdminQueuesRoute
  '/dashboard/admin/users': typeof DashboardAdminUsersRoute
  '/dashboard/analytics/ekonomika': typeof DashboardAnalyticsEkonomikaRoute
  '/dashboard/dochazka/$terminId': typeof DashboardDochazkaTerminIdRoute
  '/dashboard/firmy/$firmaId': typeof DashboardFirmyFirmaIdRoute
  '/dashboard/klienti/$klientId': typeof DashboardKlientiKlientIdRoute
  '/dashboard/marketing/email-analytics': typeof DashboardMarketingEmailAnalyticsRoute
  '/dashboard/marketing/email-campaigns': typeof DashboardMarketingEmailCampaignsRoute
  '/dashboard/marketing/email-serialy': typeof DashboardMarketingEmailSerialyRoute
  '/dashboard/marketing/email-templates': typeof DashboardMarketingEmailTemplatesRoute
  '/dashboard/marketing/komunikace': typeof DashboardMarketingKomunikaceRoute
  '/dashboard/marketing/lead-magnet': typeof DashboardMarketingLeadMagnetRoute
  '/dashboard/marketing/tags': typeof DashboardMarketingTagsRoute
  '/dashboard/pozorovani/$dochazkaId': typeof DashboardPozorovaniDochazkaIdRoute
  '/dashboard/role/asistent': typeof DashboardRoleAsistentRoute
  '/dashboard/role/lektor': typeof DashboardRoleLektorRoute
  '/dashboard/role/obchodnik': typeof DashboardRoleObchodnikRoute
  '/dashboard/role/ops': typeof DashboardRoleOpsRoute
  '/dashboard/terminy/$terminId': typeof DashboardTerminyTerminIdRoute
  '/dashboard/admin': typeof DashboardAdminIndexRoute
  '/dashboard/dochazka': typeof DashboardDochazkaIndexRoute
  '/dashboard/pozorovani': typeof DashboardPozorovaniIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/diagnoza': typeof DiagnozaRoute
  '/gdpr': typeof GdprRoute
  '/nas-tym': typeof NasTymRoute
  '/o-nas': typeof ONasRoute
  '/obchodni-podminky': typeof ObchodniPodminkyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terminy': typeof TerminyRoute
  '/zapomenute-heslo': typeof ZapomenuteHesloRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/dashboard/admin': typeof DashboardAdminRouteWithChildren
  '/dashboard/aktivity': typeof DashboardAktivityRoute
  '/dashboard/checklists': typeof DashboardChecklistsRoute
  '/dashboard/dokumenty': typeof DashboardDokumentyRoute
  '/dashboard/faktury': typeof DashboardFakturyRoute
  '/dashboard/firmy': typeof DashboardFirmyRoute
  '/dashboard/klienti': typeof DashboardKlientiRoute
  '/dashboard/kontakt': typeof DashboardKontaktRoute
  '/dashboard/lektori': typeof DashboardLektoriRoute
  '/dashboard/nastaveni': typeof DashboardNastaveniRoute
  '/dashboard/notes': typeof DashboardNotesRoute
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/pipeline': typeof DashboardPipelineRoute
  '/dashboard/prihlasky': typeof DashboardPrihlaskyRoute
  '/dashboard/produkty': typeof DashboardProduktyRoute
  '/dashboard/programy': typeof DashboardProgramyRoute
  '/dashboard/provize': typeof DashboardProvizeRoute
  '/dashboard/tasks': typeof DashboardTasksRoute
  '/dashboard/terminy': typeof DashboardTerminyRoute
  '/dashboard/zpetna-vazba': typeof DashboardZpetnaVazbaRoute
  '/kiosk/$terminId': typeof KioskTerminIdRoute
  '/odhlasit/$token': typeof OdhlasitTokenRoute
  '/potvrzeni/$token': typeof PotvrzeniTokenRoute
  '/registrace/$terminId': typeof RegistraceTerminIdRoute
  '/seminare/$slug': typeof SeminareSlugRoute
  '/zpetna-vazba/$token': typeof ZpetnaVazbaTokenRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/admin/audit': typeof DashboardAdminAuditRoute
  '/dashboard/admin/mcp': typeof DashboardAdminMcpRoute
  '/dashboard/admin/nastroje': typeof DashboardAdminNastrojeRoute
  '/dashboard/admin/queues': typeof DashboardAdminQueuesRoute
  '/dashboard/admin/users': typeof DashboardAdminUsersRoute
  '/dashboard/analytics/ekonomika': typeof DashboardAnalyticsEkonomikaRoute
  '/dashboard/dochazka/$terminId': typeof DashboardDochazkaTerminIdRoute
  '/dashboard/firmy_/$firmaId': typeof DashboardFirmyFirmaIdRoute
  '/dashboard/klienti_/$klientId': typeof DashboardKlientiKlientIdRoute
  '/dashboard/marketing/email-analytics': typeof DashboardMarketingEmailAnalyticsRoute
  '/dashboard/marketing/email-campaigns': typeof DashboardMarketingEmailCampaignsRoute
  '/dashboard/marketing/email-serialy': typeof DashboardMarketingEmailSerialyRoute
  '/dashboard/marketing/email-templates': typeof DashboardMarketingEmailTemplatesRoute
  '/dashboard/marketing/komunikace': typeof DashboardMarketingKomunikaceRoute
  '/dashboard/marketing/lead-magnet': typeof DashboardMarketingLeadMagnetRoute
  '/dashboard/marketing/tags': typeof DashboardMarketingTagsRoute
  '/dashboard/pozorovani/$dochazkaId': typeof DashboardPozorovaniDochazkaIdRoute
  '/dashboard/role/asistent': typeof DashboardRoleAsistentRoute
  '/dashboard/role/lektor': typeof DashboardRoleLektorRoute
  '/dashboard/role/obchodnik': typeof DashboardRoleObchodnikRoute
  '/dashboard/role/ops': typeof DashboardRoleOpsRoute
  '/dashboard/terminy_/$terminId': typeof DashboardTerminyTerminIdRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/dochazka/': typeof DashboardDochazkaIndexRoute
  '/dashboard/pozorovani/': typeof DashboardPozorovaniIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/diagnoza'
    | '/gdpr'
    | '/nas-tym'
    | '/o-nas'
    | '/obchodni-podminky'
    | '/reset-password'
    | '/terminy'
    | '/zapomenute-heslo'
    | '/login'
    | '/register'
    | '/dashboard/admin'
    | '/dashboard/aktivity'
    | '/dashboard/checklists'
    | '/dashboard/dokumenty'
    | '/dashboard/faktury'
    | '/dashboard/firmy'
    | '/dashboard/klienti'
    | '/dashboard/kontakt'
    | '/dashboard/lektori'
    | '/dashboard/nastaveni'
    | '/dashboard/notes'
    | '/dashboard/notifications'
    | '/dashboard/pipeline'
    | '/dashboard/prihlasky'
    | '/dashboard/produkty'
    | '/dashboard/programy'
    | '/dashboard/provize'
    | '/dashboard/tasks'
    | '/dashboard/terminy'
    | '/dashboard/zpetna-vazba'
    | '/kiosk/$terminId'
    | '/odhlasit/$token'
    | '/potvrzeni/$token'
    | '/registrace/$terminId'
    | '/seminare/$slug'
    | '/zpetna-vazba/$token'
    | '/dashboard/'
    | '/dashboard/admin/audit'
    | '/dashboard/admin/mcp'
    | '/dashboard/admin/nastroje'
    | '/dashboard/admin/queues'
    | '/dashboard/admin/users'
    | '/dashboard/analytics/ekonomika'
    | '/dashboard/dochazka/$terminId'
    | '/dashboard/firmy/$firmaId'
    | '/dashboard/klienti/$klientId'
    | '/dashboard/marketing/email-analytics'
    | '/dashboard/marketing/email-campaigns'
    | '/dashboard/marketing/email-serialy'
    | '/dashboard/marketing/email-templates'
    | '/dashboard/marketing/komunikace'
    | '/dashboard/marketing/lead-magnet'
    | '/dashboard/marketing/tags'
    | '/dashboard/pozorovani/$dochazkaId'
    | '/dashboard/role/asistent'
    | '/dashboard/role/lektor'
    | '/dashboard/role/obchodnik'
    | '/dashboard/role/ops'
    | '/dashboard/terminy/$terminId'
    | '/dashboard/admin/'
    | '/dashboard/dochazka/'
    | '/dashboard/pozorovani/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/diagnoza'
    | '/gdpr'
    | '/nas-tym'
    | '/o-nas'
    | '/obchodni-podminky'
    | '/reset-password'
    | '/terminy'
    | '/zapomenute-heslo'
    | '/login'
    | '/register'
    | '/dashboard/aktivity'
    | '/dashboard/checklists'
    | '/dashboard/dokumenty'
    | '/dashboard/faktury'
    | '/dashboard/firmy'
    | '/dashboard/klienti'
    | '/dashboard/kontakt'
    | '/dashboard/lektori'
    | '/dashboard/nastaveni'
    | '/dashboard/notes'
    | '/dashboard/notifications'
    | '/dashboard/pipeline'
    | '/dashboard/prihlasky'
    | '/dashboard/produkty'
    | '/dashboard/programy'
    | '/dashboard/provize'
    | '/dashboard/tasks'
    | '/dashboard/terminy'
    | '/dashboard/zpetna-vazba'
    | '/kiosk/$terminId'
    | '/odhlasit/$token'
    | '/potvrzeni/$token'
    | '/registrace/$terminId'
    | '/seminare/$slug'
    | '/zpetna-vazba/$token'
    | '/dashboard'
    | '/dashboard/admin/audit'
    | '/dashboard/admin/mcp'
    | '/dashboard/admin/nastroje'
    | '/dashboard/admin/queues'
    | '/dashboard/admin/users'
    | '/dashboard/analytics/ekonomika'
    | '/dashboard/dochazka/$terminId'
    | '/dashboard/firmy/$firmaId'
    | '/dashboard/klienti/$klientId'
    | '/dashboard/marketing/email-analytics'
    | '/dashboard/marketing/email-campaigns'
    | '/dashboard/marketing/email-serialy'
    | '/dashboard/marketing/email-templates'
    | '/dashboard/marketing/komunikace'
    | '/dashboard/marketing/lead-magnet'
    | '/dashboard/marketing/tags'
    | '/dashboard/pozorovani/$dochazkaId'
    | '/dashboard/role/asistent'
    | '/dashboard/role/lektor'
    | '/dashboard/role/obchodnik'
    | '/dashboard/role/ops'
    | '/dashboard/terminy/$terminId'
    | '/dashboard/admin'
    | '/dashboard/dochazka'
    | '/dashboard/pozorovani'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/dashboard'
    | '/diagnoza'
    | '/gdpr'
    | '/nas-tym'
    | '/o-nas'
    | '/obchodni-podminky'
    | '/reset-password'
    | '/terminy'
    | '/zapomenute-heslo'
    | '/_auth/login'
    | '/_auth/register'
    | '/dashboard/admin'
    | '/dashboard/aktivity'
    | '/dashboard/checklists'
    | '/dashboard/dokumenty'
    | '/dashboard/faktury'
    | '/dashboard/firmy'
    | '/dashboard/klienti'
    | '/dashboard/kontakt'
    | '/dashboard/lektori'
    | '/dashboard/nastaveni'
    | '/dashboard/notes'
    | '/dashboard/notifications'
    | '/dashboard/pipeline'
    | '/dashboard/prihlasky'
    | '/dashboard/produkty'
    | '/dashboard/programy'
    | '/dashboard/provize'
    | '/dashboard/tasks'
    | '/dashboard/terminy'
    | '/dashboard/zpetna-vazba'
    | '/kiosk/$terminId'
    | '/odhlasit/$token'
    | '/potvrzeni/$token'
    | '/registrace/$terminId'
    | '/seminare/$slug'
    | '/zpetna-vazba/$token'
    | '/dashboard/'
    | '/dashboard/admin/audit'
    | '/dashboard/admin/mcp'
    | '/dashboard/admin/nastroje'
    | '/dashboard/admin/queues'
    | '/dashboard/admin/users'
    | '/dashboard/analytics/ekonomika'
    | '/dashboard/dochazka/$terminId'
    | '/dashboard/firmy_/$firmaId'
    | '/dashboard/klienti_/$klientId'
    | '/dashboard/marketing/email-analytics'
    | '/dashboard/marketing/email-campaigns'
    | '/dashboard/marketing/email-serialy'
    | '/dashboard/marketing/email-templates'
    | '/dashboard/marketing/komunikace'
    | '/dashboard/marketing/lead-magnet'
    | '/dashboard/marketing/tags'
    | '/dashboard/pozorovani/$dochazkaId'
    | '/dashboard/role/asistent'
    | '/dashboard/role/lektor'
    | '/dashboard/role/obchodnik'
    | '/dashboard/role/ops'
    | '/dashboard/terminy_/$terminId'
    | '/dashboard/admin/'
    | '/dashboard/dochazka/'
    | '/dashboard/pozorovani/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
  DiagnozaRoute: typeof DiagnozaRoute
  GdprRoute: typeof GdprRoute
  NasTymRoute: typeof NasTymRoute
  ONasRoute: typeof ONasRoute
  ObchodniPodminkyRoute: typeof ObchodniPodminkyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TerminyRoute: typeof TerminyRoute
  ZapomenuteHesloRoute: typeof ZapomenuteHesloRoute
  KioskTerminIdRoute: typeof KioskTerminIdRoute
  OdhlasitTokenRoute: typeof OdhlasitTokenRoute
  PotvrzeniTokenRoute: typeof PotvrzeniTokenRoute
  RegistraceTerminIdRoute: typeof RegistraceTerminIdRoute
  SeminareSlugRoute: typeof SeminareSlugRoute
  ZpetnaVazbaTokenRoute: typeof ZpetnaVazbaTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/zapomenute-heslo': {
      id: '/zapomenute-heslo'
      path: '/zapomenute-heslo'
      fullPath: '/zapomenute-heslo'
      preLoaderRoute: typeof ZapomenuteHesloRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terminy': {
      id: '/terminy'
      path: '/terminy'
      fullPath: '/terminy'
      preLoaderRoute: typeof TerminyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/obchodni-podminky': {
      id: '/obchodni-podminky'
      path: '/obchodni-podminky'
      fullPath: '/obchodni-podminky'
      preLoaderRoute: typeof ObchodniPodminkyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o-nas': {
      id: '/o-nas'
      path: '/o-nas'
      fullPath: '/o-nas'
      preLoaderRoute: typeof ONasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nas-tym': {
      id: '/nas-tym'
      path: '/nas-tym'
      fullPath: '/nas-tym'
      preLoaderRoute: typeof NasTymRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gdpr': {
      id: '/gdpr'
      path: '/gdpr'
      fullPath: '/gdpr'
      preLoaderRoute: typeof GdprRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagnoza': {
      id: '/diagnoza'
      path: '/diagnoza'
      fullPath: '/diagnoza'
      preLoaderRoute: typeof DiagnozaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/zpetna-vazba/$token': {
      id: '/zpetna-vazba/$token'
      path: '/zpetna-vazba/$token'
      fullPath: '/zpetna-vazba/$token'
      preLoaderRoute: typeof ZpetnaVazbaTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seminare/$slug': {
      id: '/seminare/$slug'
      path: '/seminare/$slug'
      fullPath: '/seminare/$slug'
      preLoaderRoute: typeof SeminareSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registrace/$terminId': {
      id: '/registrace/$terminId'
      path: '/registrace/$terminId'
      fullPath: '/registrace/$terminId'
      preLoaderRoute: typeof RegistraceTerminIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/potvrzeni/$token': {
      id: '/potvrzeni/$token'
      path: '/potvrzeni/$token'
      fullPath: '/potvrzeni/$token'
      preLoaderRoute: typeof PotvrzeniTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/odhlasit/$token': {
      id: '/odhlasit/$token'
      path: '/odhlasit/$token'
      fullPath: '/odhlasit/$token'
      preLoaderRoute: typeof OdhlasitTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk/$terminId': {
      id: '/kiosk/$terminId'
      path: '/kiosk/$terminId'
      fullPath: '/kiosk/$terminId'
      preLoaderRoute: typeof KioskTerminIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/zpetna-vazba': {
      id: '/dashboard/zpetna-vazba'
      path: '/zpetna-vazba'
      fullPath: '/dashboard/zpetna-vazba'
      preLoaderRoute: typeof DashboardZpetnaVazbaRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/terminy': {
      id: '/dashboard/terminy'
      path: '/terminy'
      fullPath: '/dashboard/terminy'
      preLoaderRoute: typeof DashboardTerminyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/tasks': {
      id: '/dashboard/tasks'
      path: '/tasks'
      fullPath: '/dashboard/tasks'
      preLoaderRoute: typeof DashboardTasksRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/provize': {
      id: '/dashboard/provize'
      path: '/provize'
      fullPath: '/dashboard/provize'
      preLoaderRoute: typeof DashboardProvizeRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/programy': {
      id: '/dashboard/programy'
      path: '/programy'
      fullPath: '/dashboard/programy'
      preLoaderRoute: typeof DashboardProgramyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/produkty': {
      id: '/dashboard/produkty'
      path: '/produkty'
      fullPath: '/dashboard/produkty'
      preLoaderRoute: typeof DashboardProduktyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/prihlasky': {
      id: '/dashboard/prihlasky'
      path: '/prihlasky'
      fullPath: '/dashboard/prihlasky'
      preLoaderRoute: typeof DashboardPrihlaskyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/pipeline': {
      id: '/dashboard/pipeline'
      path: '/pipeline'
      fullPath: '/dashboard/pipeline'
      preLoaderRoute: typeof DashboardPipelineRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/notifications': {
      id: '/dashboard/notifications'
      path: '/notifications'
      fullPath: '/dashboard/notifications'
      preLoaderRoute: typeof DashboardNotificationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/notes': {
      id: '/dashboard/notes'
      path: '/notes'
      fullPath: '/dashboard/notes'
      preLoaderRoute: typeof DashboardNotesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/nastaveni': {
      id: '/dashboard/nastaveni'
      path: '/nastaveni'
      fullPath: '/dashboard/nastaveni'
      preLoaderRoute: typeof DashboardNastaveniRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/lektori': {
      id: '/dashboard/lektori'
      path: '/lektori'
      fullPath: '/dashboard/lektori'
      preLoaderRoute: typeof DashboardLektoriRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/kontakt': {
      id: '/dashboard/kontakt'
      path: '/kontakt'
      fullPath: '/dashboard/kontakt'
      preLoaderRoute: typeof DashboardKontaktRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/klienti': {
      id: '/dashboard/klienti'
      path: '/klienti'
      fullPath: '/dashboard/klienti'
      preLoaderRoute: typeof DashboardKlientiRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/firmy': {
      id: '/dashboard/firmy'
      path: '/firmy'
      fullPath: '/dashboard/firmy'
      preLoaderRoute: typeof DashboardFirmyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/faktury': {
      id: '/dashboard/faktury'
      path: '/faktury'
      fullPath: '/dashboard/faktury'
      preLoaderRoute: typeof DashboardFakturyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/dokumenty': {
      id: '/dashboard/dokumenty'
      path: '/dokumenty'
      fullPath: '/dashboard/dokumenty'
      preLoaderRoute: typeof DashboardDokumentyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/checklists': {
      id: '/dashboard/checklists'
      path: '/checklists'
      fullPath: '/dashboard/checklists'
      preLoaderRoute: typeof DashboardChecklistsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/aktivity': {
      id: '/dashboard/aktivity'
      path: '/aktivity'
      fullPath: '/dashboard/aktivity'
      preLoaderRoute: typeof DashboardAktivityRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin': {
      id: '/dashboard/admin'
      path: '/admin'
      fullPath: '/dashboard/admin'
      preLoaderRoute: typeof DashboardAdminRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/dashboard/pozorovani/': {
      id: '/dashboard/pozorovani/'
      path: '/pozorovani'
      fullPath: '/dashboard/pozorovani/'
      preLoaderRoute: typeof DashboardPozorovaniIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/dochazka/': {
      id: '/dashboard/dochazka/'
      path: '/dochazka'
      fullPath: '/dashboard/dochazka/'
      preLoaderRoute: typeof DashboardDochazkaIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/': {
      id: '/dashboard/admin/'
      path: '/'
      fullPath: '/dashboard/admin/'
      preLoaderRoute: typeof DashboardAdminIndexRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/terminy_/$terminId': {
      id: '/dashboard/terminy_/$terminId'
      path: '/terminy/$terminId'
      fullPath: '/dashboard/terminy/$terminId'
      preLoaderRoute: typeof DashboardTerminyTerminIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/role/ops': {
      id: '/dashboard/role/ops'
      path: '/role/ops'
      fullPath: '/dashboard/role/ops'
      preLoaderRoute: typeof DashboardRoleOpsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/role/obchodnik': {
      id: '/dashboard/role/obchodnik'
      path: '/role/obchodnik'
      fullPath: '/dashboard/role/obchodnik'
      preLoaderRoute: typeof DashboardRoleObchodnikRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/role/lektor': {
      id: '/dashboard/role/lektor'
      path: '/role/lektor'
      fullPath: '/dashboard/role/lektor'
      preLoaderRoute: typeof DashboardRoleLektorRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/role/asistent': {
      id: '/dashboard/role/asistent'
      path: '/role/asistent'
      fullPath: '/dashboard/role/asistent'
      preLoaderRoute: typeof DashboardRoleAsistentRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/pozorovani/$dochazkaId': {
      id: '/dashboard/pozorovani/$dochazkaId'
      path: '/pozorovani/$dochazkaId'
      fullPath: '/dashboard/pozorovani/$dochazkaId'
      preLoaderRoute: typeof DashboardPozorovaniDochazkaIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/marketing/tags': {
      id: '/dashboard/marketing/tags'
      path: '/marketing/tags'
      fullPath: '/dashboard/marketing/tags'
      preLoaderRoute: typeof DashboardMarketingTagsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/marketing/lead-magnet': {
      id: '/dashboard/marketing/lead-magnet'
      path: '/marketing/lead-magnet'
      fullPath: '/dashboard/marketing/lead-magnet'
      preLoaderRoute: typeof DashboardMarketingLeadMagnetRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/marketing/komunikace': {
      id: '/dashboard/marketing/komunikace'
      path: '/marketing/komunikace'
      fullPath: '/dashboard/marketing/komunikace'
      preLoaderRoute: typeof DashboardMarketingKomunikaceRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/marketing/email-templates': {
      id: '/dashboard/marketing/email-templates'
      path: '/marketing/email-templates'
      fullPath: '/dashboard/marketing/email-templates'
      preLoaderRoute: typeof DashboardMarketingEmailTemplatesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/marketing/email-serialy': {
      id: '/dashboard/marketing/email-serialy'
      path: '/marketing/email-serialy'
      fullPath: '/dashboard/marketing/email-serialy'
      preLoaderRoute: typeof DashboardMarketingEmailSerialyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/marketing/email-campaigns': {
      id: '/dashboard/marketing/email-campaigns'
      path: '/marketing/email-campaigns'
      fullPath: '/dashboard/marketing/email-campaigns'
      preLoaderRoute: typeof DashboardMarketingEmailCampaignsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/marketing/email-analytics': {
      id: '/dashboard/marketing/email-analytics'
      path: '/marketing/email-analytics'
      fullPath: '/dashboard/marketing/email-analytics'
      preLoaderRoute: typeof DashboardMarketingEmailAnalyticsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/klienti_/$klientId': {
      id: '/dashboard/klienti_/$klientId'
      path: '/klienti/$klientId'
      fullPath: '/dashboard/klienti/$klientId'
      preLoaderRoute: typeof DashboardKlientiKlientIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/firmy_/$firmaId': {
      id: '/dashboard/firmy_/$firmaId'
      path: '/firmy/$firmaId'
      fullPath: '/dashboard/firmy/$firmaId'
      preLoaderRoute: typeof DashboardFirmyFirmaIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/dochazka/$terminId': {
      id: '/dashboard/dochazka/$terminId'
      path: '/dochazka/$terminId'
      fullPath: '/dashboard/dochazka/$terminId'
      preLoaderRoute: typeof DashboardDochazkaTerminIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/analytics/ekonomika': {
      id: '/dashboard/analytics/ekonomika'
      path: '/analytics/ekonomika'
      fullPath: '/dashboard/analytics/ekonomika'
      preLoaderRoute: typeof DashboardAnalyticsEkonomikaRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/users': {
      id: '/dashboard/admin/users'
      path: '/users'
      fullPath: '/dashboard/admin/users'
      preLoaderRoute: typeof DashboardAdminUsersRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/admin/queues': {
      id: '/dashboard/admin/queues'
      path: '/queues'
      fullPath: '/dashboard/admin/queues'
      preLoaderRoute: typeof DashboardAdminQueuesRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/admin/nastroje': {
      id: '/dashboard/admin/nastroje'
      path: '/nastroje'
      fullPath: '/dashboard/admin/nastroje'
      preLoaderRoute: typeof DashboardAdminNastrojeRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/admin/mcp': {
      id: '/dashboard/admin/mcp'
      path: '/mcp'
      fullPath: '/dashboard/admin/mcp'
      preLoaderRoute: typeof DashboardAdminMcpRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/admin/audit': {
      id: '/dashboard/admin/audit'
      path: '/audit'
      fullPath: '/dashboard/admin/audit'
      preLoaderRoute: typeof DashboardAdminAuditRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardAdminRouteChildren {
  DashboardAdminAuditRoute: typeof DashboardAdminAuditRoute
  DashboardAdminMcpRoute: typeof DashboardAdminMcpRoute
  DashboardAdminNastrojeRoute: typeof DashboardAdminNastrojeRoute
  DashboardAdminQueuesRoute: typeof DashboardAdminQueuesRoute
  DashboardAdminUsersRoute: typeof DashboardAdminUsersRoute
  DashboardAdminIndexRoute: typeof DashboardAdminIndexRoute
}

const DashboardAdminRouteChildren: DashboardAdminRouteChildren = {
  DashboardAdminAuditRoute: DashboardAdminAuditRoute,
  DashboardAdminMcpRoute: DashboardAdminMcpRoute,
  DashboardAdminNastrojeRoute: DashboardAdminNastrojeRoute,
  DashboardAdminQueuesRoute: DashboardAdminQueuesRoute,
  DashboardAdminUsersRoute: DashboardAdminUsersRoute,
  DashboardAdminIndexRoute: DashboardAdminIndexRoute,
}

const DashboardAdminRouteWithChildren = DashboardAdminRoute._addFileChildren(
  DashboardAdminRouteChildren,
)

interface DashboardRouteChildren {
  DashboardAdminRoute: typeof DashboardAdminRouteWithChildren
  DashboardAktivityRoute: typeof DashboardAktivityRoute
  DashboardChecklistsRoute: typeof DashboardChecklistsRoute
  DashboardDokumentyRoute: typeof DashboardDokumentyRoute
  DashboardFakturyRoute: typeof DashboardFakturyRoute
  DashboardFirmyRoute: typeof DashboardFirmyRoute
  DashboardKlientiRoute: typeof DashboardKlientiRoute
  DashboardKontaktRoute: typeof DashboardKontaktRoute
  DashboardLektoriRoute: typeof DashboardLektoriRoute
  DashboardNastaveniRoute: typeof DashboardNastaveniRoute
  DashboardNotesRoute: typeof DashboardNotesRoute
  DashboardNotificationsRoute: typeof DashboardNotificationsRoute
  DashboardPipelineRoute: typeof DashboardPipelineRoute
  DashboardPrihlaskyRoute: typeof DashboardPrihlaskyRoute
  DashboardProduktyRoute: typeof DashboardProduktyRoute
  DashboardProgramyRoute: typeof DashboardProgramyRoute
  DashboardProvizeRoute: typeof DashboardProvizeRoute
  DashboardTasksRoute: typeof DashboardTasksRoute
  DashboardTerminyRoute: typeof DashboardTerminyRoute
  DashboardZpetnaVazbaRoute: typeof DashboardZpetnaVazbaRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardAnalyticsEkonomikaRoute: typeof DashboardAnalyticsEkonomikaRoute
  DashboardDochazkaTerminIdRoute: typeof DashboardDochazkaTerminIdRoute
  DashboardFirmyFirmaIdRoute: typeof DashboardFirmyFirmaIdRoute
  DashboardKlientiKlientIdRoute: typeof DashboardKlientiKlientIdRoute
  DashboardMarketingEmailAnalyticsRoute: typeof DashboardMarketingEmailAnalyticsRoute
  DashboardMarketingEmailCampaignsRoute: typeof DashboardMarketingEmailCampaignsRoute
  DashboardMarketingEmailSerialyRoute: typeof DashboardMarketingEmailSerialyRoute
  DashboardMarketingEmailTemplatesRoute: typeof DashboardMarketingEmailTemplatesRoute
  DashboardMarketingKomunikaceRoute: typeof DashboardMarketingKomunikaceRoute
  DashboardMarketingLeadMagnetRoute: typeof DashboardMarketingLeadMagnetRoute
  DashboardMarketingTagsRoute: typeof DashboardMarketingTagsRoute
  DashboardPozorovaniDochazkaIdRoute: typeof DashboardPozorovaniDochazkaIdRoute
  DashboardRoleAsistentRoute: typeof DashboardRoleAsistentRoute
  DashboardRoleLektorRoute: typeof DashboardRoleLektorRoute
  DashboardRoleObchodnikRoute: typeof DashboardRoleObchodnikRoute
  DashboardRoleOpsRoute: typeof DashboardRoleOpsRoute
  DashboardTerminyTerminIdRoute: typeof DashboardTerminyTerminIdRoute
  DashboardDochazkaIndexRoute: typeof DashboardDochazkaIndexRoute
  DashboardPozorovaniIndexRoute: typeof DashboardPozorovaniIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAdminRoute: DashboardAdminRouteWithChildren,
  DashboardAktivityRoute: DashboardAktivityRoute,
  DashboardChecklistsRoute: DashboardChecklistsRoute,
  DashboardDokumentyRoute: DashboardDokumentyRoute,
  DashboardFakturyRoute: DashboardFakturyRoute,
  DashboardFirmyRoute: DashboardFirmyRoute,
  DashboardKlientiRoute: DashboardKlientiRoute,
  DashboardKontaktRoute: DashboardKontaktRoute,
  DashboardLektoriRoute: DashboardLektoriRoute,
  DashboardNastaveniRoute: DashboardNastaveniRoute,
  DashboardNotesRoute: DashboardNotesRoute,
  DashboardNotificationsRoute: DashboardNotificationsRoute,
  DashboardPipelineRoute: DashboardPipelineRoute,
  DashboardPrihlaskyRoute: DashboardPrihlaskyRoute,
  DashboardProduktyRoute: DashboardProduktyRoute,
  DashboardProgramyRoute: DashboardProgramyRoute,
  DashboardProvizeRoute: DashboardProvizeRoute,
  DashboardTasksRoute: DashboardTasksRoute,
  DashboardTerminyRoute: DashboardTerminyRoute,
  DashboardZpetnaVazbaRoute: DashboardZpetnaVazbaRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardAnalyticsEkonomikaRoute: DashboardAnalyticsEkonomikaRoute,
  DashboardDochazkaTerminIdRoute: DashboardDochazkaTerminIdRoute,
  DashboardFirmyFirmaIdRoute: DashboardFirmyFirmaIdRoute,
  DashboardKlientiKlientIdRoute: DashboardKlientiKlientIdRoute,
  DashboardMarketingEmailAnalyticsRoute: DashboardMarketingEmailAnalyticsRoute,
  DashboardMarketingEmailCampaignsRoute: DashboardMarketingEmailCampaignsRoute,
  DashboardMarketingEmailSerialyRoute: DashboardMarketingEmailSerialyRoute,
  DashboardMarketingEmailTemplatesRoute: DashboardMarketingEmailTemplatesRoute,
  DashboardMarketingKomunikaceRoute: DashboardMarketingKomunikaceRoute,
  DashboardMarketingLeadMagnetRoute: DashboardMarketingLeadMagnetRoute,
  DashboardMarketingTagsRoute: DashboardMarketingTagsRoute,
  DashboardPozorovaniDochazkaIdRoute: DashboardPozorovaniDochazkaIdRoute,
  DashboardRoleAsistentRoute: DashboardRoleAsistentRoute,
  DashboardRoleLektorRoute: DashboardRoleLektorRoute,
  DashboardRoleObchodnikRoute: DashboardRoleObchodnikRoute,
  DashboardRoleOpsRoute: DashboardRoleOpsRoute,
  DashboardTerminyTerminIdRoute: DashboardTerminyTerminIdRoute,
  DashboardDochazkaIndexRoute: DashboardDochazkaIndexRoute,
  DashboardPozorovaniIndexRoute: DashboardPozorovaniIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
  DiagnozaRoute: DiagnozaRoute,
  GdprRoute: GdprRoute,
  NasTymRoute: NasTymRoute,
  ONasRoute: ONasRoute,
  ObchodniPodminkyRoute: ObchodniPodminkyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TerminyRoute: TerminyRoute,
  ZapomenuteHesloRoute: ZapomenuteHesloRoute,
  KioskTerminIdRoute: KioskTerminIdRoute,
  OdhlasitTokenRoute: OdhlasitTokenRoute,
  PotvrzeniTokenRoute: PotvrzeniTokenRoute,
  RegistraceTerminIdRoute: RegistraceTerminIdRoute,
  SeminareSlugRoute: SeminareSlugRoute,
  ZpetnaVazbaTokenRoute: ZpetnaVazbaTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
